var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758002565274,
    className: "icon",
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6014,
    width: 16.015625,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 347.2c-52.4 16.8 0.4 66.4 0.4 66.4l176.8 147.6 550.8-326c0 0-372 286.4-485.6 375.2l383.6 290c60.8 40 76.4 8 76.4 8l26.8-63.2 270.4-752.4c10-26-18.4-56-49.2-51.2L23.2 347.2 23.2 347.2M414.8 787.6l-146.8-109.6-0.4 212L414.8 787.6 414.8 787.6M414.8 787.6",
    "p-id": 6015
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.eba257b5.svg";
export { ForwardRef as ReactComponent };